import { SVGProps } from 'react';

const EditIcon = ({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    id='edit_icon'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    className='stroke-current'
    {...props}
  >
    <g id='ic-contact-edit' transform='translate(0.002 0.028)'>
      <path
        id='Path_80'
        data-name='Path 80'
        d='M16.74,4.55a1.63,1.63,0,0,0-2.29.07l-10,10h0l-.31,4.86a.33.33,0,0,0,.35.35l4.86-.31h0l10-10a1.63,1.63,0,0,0,.07-2.29Z'
        fill='rgba(0,0,0,0)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </g>
  </svg>
);

export default EditIcon;
